export default __webpack_public_path__ + "images/BZ.563869d.png";